export const ACCESS_TOKEN_EXPIRY_LEEWAY_MS = 30_000;

function decodeBase64Url(value: string): string {
  const base64 = value.replaceAll('-', '+').replaceAll('_', '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  const bytes = Uint8Array.from(window.atob(padded), (character) => character.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function getAccessTokenExpiry(accessToken: string): number | null {
  const payload = accessToken.split('.')[1];
  if (payload === undefined) {
    return null;
  }
  try {
    const claims: unknown = JSON.parse(decodeBase64Url(payload));
    if (typeof claims !== 'object' || claims === null) {
      return null;
    }
    const { exp } = claims as { exp?: unknown };
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}

export function getAccessTokenSub(accessToken: string): string | null {
  const payload = accessToken.split('.')[1];
  if (payload === undefined) {
    return null;
  }
  try {
    const claims: unknown = JSON.parse(decodeBase64Url(payload));
    if (typeof claims !== 'object' || claims === null) {
      return null;
    }
    const { sub } = claims as { sub?: unknown };
    return typeof sub === 'string' ? sub : null;
  } catch {
    return null;
  }
}

export function isAccessTokenExpired(accessToken: string): boolean {
  const expiresAt = getAccessTokenExpiry(accessToken);
  return expiresAt === null || expiresAt - ACCESS_TOKEN_EXPIRY_LEEWAY_MS <= Date.now();
}
